/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = React.forwardRef(({
  className, align = 'end', sideOffset = 8, ...props
}, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'tyre-management-v2 z-[1400] w-80 rounded-xl border border-solid border-slate-300 bg-white p-4 text-slate-950 shadow-xl outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));

PopoverContent.displayName = 'PopoverContent';
PopoverContent.propTypes = {
  className: PropTypes.string,
  align: PropTypes.string,
  sideOffset: PropTypes.number,
};
